import { User } from '../types';

export const USERS: User[] = [
  {
    id: 'user_shivam',
    name: 'Shivam',
    email: 'shivam@shivamstudio.com',
    password: 'SS@Admin2026#',
    role: 'admin',
    canSeeNPNL: true,
    canSeeInternalCost: true,
  },
  {
    id: 'user_coo',
    name: 'COO',
    email: 'coo@shivamstudio.com',
    password: 'SS@COO2026#',
    role: 'coo',
    canSeeNPNL: false,
    canSeeInternalCost: true,
  },
  {
    id: 'user_md',
    name: 'Laxmikant',
    email: 'laxmikant@shivamstudio.com',
    password: 'SS@MD2026#',
    role: 'md',
    canSeeNPNL: false,
    canSeeInternalCost: true,
  },
  {
    id: 'user_cto',
    name: 'CTO',
    email: 'cto@shivamstudio.com',
    password: 'SS@CTO2026#',
    role: 'cto',
    canSeeNPNL: false,
    canSeeInternalCost: false,
  },
  {
    id: 'user_emp',
    name: 'Employee',
    email: 'employee@shivamstudio.com',
    password: 'SS@Emp2026#',
    role: 'employee',
    canSeeNPNL: false,
    canSeeInternalCost: false,
  },
];
